//appSessionStore.js
//session storage utils to help maintain UI state

let APP_SESSION_KEY = "vivialconnect";

const init = ({ config }) => {
  if (config.APP_NAME) APP_SESSION_KEY = `__${btoa(config.APP_NAME)}__`;
};

const get = () => {
  return JSON.parse(sessionStorage.getItem(APP_SESSION_KEY));
};

const set = (data) => {
  return sessionStorage.setItem(APP_SESSION_KEY, JSON.stringify(data));
};

const clear = () => {
  sessionStorage.removeItem(APP_SESSION_KEY);
};

const getAccountId = () => {
  const store = get();
  return store ? store.id : undefined;
};

export default {
  init,
  get,
  set,
  clear,
  getAccountId,
};
